import type { ParsedUrlQuery } from 'querystring'

import type { PageIdExtra } from '@/Providers'

function safeJsonParse<T>(value: string): T | null {
  try {
    return JSON.parse(value) as T
  } catch {
    return null
  }
}

export function parseExtraParam(extra: unknown): PageIdExtra {
  //  extra가 이미 object로 들어온 경우
  if (extra && typeof extra === 'object' && !Array.isArray(extra)) {
    return normalizeExtra(extra as PageIdExtra)
  }

  // string[]이면 첫 값 사용
  const raw = Array.isArray(extra)
    ? extra[0]
    : typeof extra === 'string'
      ? extra
      : ''

  if (!raw) return {}

  // raw JSON 우선
  const parsed1 = safeJsonParse<PageIdExtra>(raw)
  if (parsed1) return normalizeExtra(parsed1)

  // encoded JSON fallback
  const decoded = decodeURIComponent(raw)
  const parsed2 = safeJsonParse<PageIdExtra>(decoded)
  return normalizeExtra(parsed2 ?? {})
}

function normalizeExtra(extra: PageIdExtra): PageIdExtra {
  // open_profile -> openProfile 같은 매핑이 필요하면 여기서 처리
  const toggle = (extra as any).toggleTab
  if (toggle === 'open_profile') {
    return { ...extra, toggleTab: 'openProfile' }
  }
  return extra
}

export function getExtraObjectFromQuery(query: ParsedUrlQuery): PageIdExtra {
  // next/router query.extra
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return parseExtraParam((query as any).extra)
}

export function getToggleTab(extra: unknown): unknown {
  return parseExtraParam(extra)?.toggleTab
}

export function getProfileId(extra: unknown): string | undefined {
  const v = parseExtraParam(extra)?.profileId
  return typeof v === 'string' && v ? v : undefined
}

/** extra 파라미터를 한 번만 파싱하여 json 형태로 반환 */
export function parseQuery2ExtraObj<
  T extends Record<string, any> = Record<string, any>,
>(query: ParsedUrlQuery): T {
  const extra = query.extra
  const empty = {} as T

  const raw = Array.isArray(extra)
    ? extra[0]
    : typeof extra === 'string'
      ? extra
      : ''

  if (!raw) return empty

  // raw JSON 우선 시도
  const parsed1 = safeJsonParse<T>(raw)
  if (parsed1) return parsed1
  // encoded JSON fallback
  const parsed2 = safeJsonParse<T>(decodeURIComponent(raw))
  return parsed2 ?? empty
}
